import React from "react";
import PropTypes from "prop-types";

var VisuallyHidden = function VisuallyHidden(props) {
  return /*#__PURE__*/React.createElement("span", {
    className: "et--visually-hidden"
  }, props.children);
};

VisuallyHidden.propTypes = {};
export default VisuallyHidden;